(function ($) {
  var form = $('.js-poll');
  var answer;

  form
    .on('change', function (event) {
      form
        // Animer la réponse choisie
        .find('.poll--active :checked')
        .parents('.poll__answer')
        .css('animation-delay', '0s')
        .addClass('animated bounceOut')

        // Animer les autres réponses
        .siblings()
        .addClass('animated bounceOut')
        .last()
        .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
          // Cacher la question courante
          var question = form.find('.poll--active').removeClass('poll--active');
          answer = question.find(':checked').val();

          // Récupérer la question suivante
          var nextQuestion = question.nextAll('[data-question="' + parseInt($(event.target).val()) + '"]');

          if (nextQuestion.length) {
            // Afficher la question suivante
            nextQuestion.addClass('poll--active');
          } else {
            // Afficher la recherche en cours
            form.find('.poll:last').addClass('poll--active');
            form.trigger('load');
          }
        });
    })
    .on('load', function () {
      // Simuler la recherche
      var i = 0;
      var delay = 200;

      var incrementCounter = function () {
        window.clearInterval(interval);

        $('.js-percentage').text(i + '%');

        i++;

        if (i !== 100) {
          // Interval aléatoire entre 0 et 100
          delay = Math.floor(Math.random() * 100) + 1;
          interval = window.setInterval(incrementCounter, delay);
        } else {
          // Afficher le résulat de la recherche
          form.trigger('submit');
        }
      };

      var interval = window.setInterval(incrementCounter, delay);
    })
    .on('submit', function (event) {
      event.preventDefault();

      // Afficher le résultat
      form.add($('.js-panel-result[data-category="' + answer + '"]')).toggleClass('hidden');
    });
})(jQuery);
